import React, { useState } from "react";
import Linkify from "react-linkify";
import filtersStore from "../../filters/SocialPostFiltersStore";



export const ActivityStreamText = (
  ({
    text,
    onClickHashtag = hashtag => filtersStore.setFilters({ text: hashtag}),
    dispatch, // passed from react-redux connect. Don't pass this prop along to <div>
    ...props
   }) => {
  const [isTruncated, setIsTruncated] = useState(true);
  const max = 200
  let truncatedText = isTruncated ? text.slice(0, max) : text;
  let wouldTruncate = text.length > 200

  return (
    <div
      {...props}
    >
      <Linkify properties={{target: '_blank'}}>
        <span className="social-message">{truncatedText}</span>
      </Linkify> {
        wouldTruncate && isTruncated
          ? <LinkButton
             onClick={() => setIsTruncated(false)}>[...]</LinkButton>
          : wouldTruncate
            ? <LinkButton
               onClick={() => setIsTruncated(true)}>[less]</LinkButton>
            : ''
      }
    </div>
  )
})

const LinkButton = (props) => <button className="btn btn-link p-0 d-inline" {...props} />

export default ActivityStreamText
